import { Routes } from '@angular/router';
import { SubscriptionGuard } from '@dss-libs/portal/guard/portal-guards';
import { contractOrderRoutes } from './contract-order/contract-order.routes';
import { AuthGuard } from '@dss-libs/shared/guard/common-guards';
import { settingsRoutes } from './settings/settings.routes';
import { UserRole } from '@dss-libs/shared/type/common-types';

export const portalCoreRoutes: Routes = [
  {
    path: '',
    canActivate: [SubscriptionGuard],
    canActivateChild: [SubscriptionGuard],
    children: contractOrderRoutes,
    loadComponent: () => import('./contract-order/contract-order.component').then((m) => m.ContractOrderComponent),
  },
  {
    path: 'settings/change-plan',
    canActivate: [AuthGuard],
    loadComponent: () => import('@dss-libs/portal/feature/settings').then((m) => m.ChangePlanComponent),
    data: {
      authorizedRole: UserRole.Owner,
    },
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadComponent: () => import('./settings/settings.component').then((m) => m.SettingsComponent),
    data: {
      authorizedRole: UserRole.User,
    },
    children: settingsRoutes,
  },
  {
    path: 'manage-subscription/transaction-history',
    loadComponent: () => import('@dss-libs/portal/feature/settings').then((m) => m.TransactionHistoryComponent),
  },
];
